module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-34-c7d9d8d35cc370c7a1b6e79955feb5e2.jpg";